<template>
  <ul class="selfcheck-progress">
    <li :class="{ now: activeIndex === 0 }">1 {{ $t('selfcheck.dishesConfirm') }}</li>
    <li :class="{ now: activeIndex === 1 }">2 {{ $t('selfcheck.paymentConfirm') }}</li>
    <li :class="{ now: activeIndex === 2 }">3 {{ $t('common.check') }}</li>
  </ul>
</template>

<script>
export default {
  name: 'SelfcheckProgress',
  props: {
    activeIndex: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.selfcheck-progress {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  border: solid 2px #808080;
  border-radius: 5px;
  color: #808080;

  li {
    position: relative;
    width: 34%;
    padding: 3px;
    list-style: none;
    text-align: center;
    font-size: 12px;

    &::before {
      content: ' ';
      position: absolute;
      left: 99%;
      top: 0;
      width: 0;
      height: 0;
      border: solid transparent;
      border-width: 12px;
      border-left-color: #fff;
      z-index: 1;
    }
    &::after {
      content: ' ';
      position: absolute;
      left: 99%;
      top: -2px;
      width: 0;
      height: 0;
      border: solid transparent;
      border-width: 14px;
      border-left-color: #808080;
    }
    &:last-child {
      &::before,
      &::after {
        content: none;
      }
    }
    &.now {
      background: #808080;
      color: #fff;

      &::after {
        z-index: 10;
      }
    }
  }
}
</style>
